export class ConsoleLogger {
    info(message, ...optionalParams) {
        // tslint:disable-next-line no-console
        console.info(message, ...optionalParams);
    }
    error(message, ...optionalParams) {
        // tslint:disable-next-line no-console
        console.error(message, ...optionalParams);
    }
}
